import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { Link as RouterLink } from "react-router-dom";

import { PATHS } from "../type/EnumPaths";

type BrandLinkProps = {
  manufacturer?: string,
}

const BrandLink = (props: BrandLinkProps) => {
  const { manufacturer } = props;

  if (!manufacturer) return null;
  
  return (
    <Typography
      component="span"
      variant="subtitle2"
      fontStyle="italic"
    >
      <Link
        color="inherit"
        to={`/${PATHS.BRANDS}/${manufacturer}`}
        key={`manufacturer-link-${manufacturer}`}
        component={RouterLink}
      >
        {manufacturer}
      </Link>
    </Typography>
  )
}

export default BrandLink;